export const AccordeonPageActions = ({updateData, triggerAction}) => {
    return {
        INIT_ACCORDEON: () => {
            updateData(false, "/appstate/standalone")
            triggerAction("SCHIESSPLATZ_CHANGE_BUDGET")
        },
    }
}